class IconListSwiper extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.swiperContainer = this.querySelector('.swiper');
        this.speed = this.getAttribute('data-speed') || 3000; // 获取滑动速度
        this.autoplayhe = parseInt(this.getAttribute('data-autoplayhe'));
    }

    connectedCallback() {
        this.initSwiper();
    }

    initSwiper() {
        if (this.swiperContainer) {
            // Swiper 基础配置对象
            const swiperConfig = {
                loop: true,
                allowTouchMove: false,
                speed: parseInt(this.speed), // 使用从 data-speed 中获取的速度值
                slidesPerView: 'auto',
                spaceBetween: 150,
                freeMode: true,
                breakpoints: {
                    1440: {
                        spaceBetween: 150,
                    },
                    1024: {
                        spaceBetween: 100,
                    },
                    590: {
                        spaceBetween: 80,
                    },
                    320: {
                        spaceBetween: 30,
                    }
                },
            };

            // 如果 this.autoplayhe == 1，则添加 autoplay 配置
            if (this.autoplayhe === 1) {
                swiperConfig.autoplay = {
                    delay: 100,  // 设置 100 毫秒延迟
                    disableOnInteraction: false,
                    stopOnLastSlide: false,
                };
            }

            // 初始化 Swiper
            this.swiper = new Swiper(this.swiperContainer, swiperConfig);

            if (window.innerWidth > 999) {
                this.swiperContainer.addEventListener('mouseenter', () => {
                    this.swiper.autoplay?.stop();  // 停止自动播放，确保 autoplay 存在
                });

                this.swiperContainer.addEventListener('mouseleave', () => {
                    this.swiper.autoplay?.start();  // 重新开始自动播放，确保 autoplay 存在
                });
            }
        }
    }
}

customElements.define('iconlist-swiper', IconListSwiper);
